/* eslint-disable jsx-a11y/anchor-has-content,react/no-unused-prop-types */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import { t } from 'utils/translates';

import {
  initState,
  changeFieldFiles,
  sendRequest,
  selectRequestState
} from 'mt-react-common/modules/tasks/common/reducers/execAddMaterialsReducer';
import OpacityPreLoader from '../../../Common/PreLoaders/OpacityPreLoader';

class TasksExecsMaterialsButtonPopUpForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileUrlFromUploaded: '',
      files: {}, // Можно тут хранить файлы, управлять ими, выводить их в представлении до отправки на сервер
      execsMaterialsPopUpId: `execsMaterialsPopUp-${this.props.exec.id}`
    };
  }

  componentDidUpdate() {
    if (this.props.requestState.hasSuccessQuery) {
      // eslint-disable-next-line no-undef
      $(`#${this.state.execsMaterialsPopUpId}`).modal('hide');
    }
  }
  handleUploadFilesByUrl = () => {
    this.props.changeFieldFiles([this.state.fileUrlFromUploaded]);
    this.props.sendRequest();
  };

  handleUploadFiles = files => {
    const filesKeys = Object.keys(files);
    if (filesKeys.length > 0) {
      const filesArray = {};
      filesKeys.map(key => {
        filesArray[files[key].name] = files[key];
        return null;
      });
      this.props.changeFieldFiles(filesArray);
      this.props.sendRequest();
    }
  };

  render() {
    return (
      <React.Fragment>
        <a
          className="btn btn-link btn-muted pull-left"
          data-toggle="modal"
          type="button"
          href={`#${this.state.execsMaterialsPopUpId}`}
        >
          <i className="fa fa-cloud-download" /> {t('Добавить материалы')}
        </a>
        <div
          aria-labelledby="myModalLabel"
          className="modal fade"
          role="dialog"
          tabIndex="-1"
          id={this.state.execsMaterialsPopUpId}
        >
          <article className="modal-dialog modal-lg modal-gray" role="document">
            <div className="modal-content">
              <div className="modal-header text-center">
                <a
                  aria-label="Close"
                  className="close close-black close-middle"
                  data-dismiss="modal"
                  href=""
                />
                <h2 className="modal-title h4">
                  <i className="fa fa-picture-o" /> {t('Загрузка изображения')}
                </h2>
              </div>
              <div className="modal-body" style={{ height: '180px' }}>
                {this.props.requestState.hasInProgress ? (
                  <OpacityPreLoader />
                ) : null}
                <div className="form-group m-b-0">
                  {Object.keys(this.state.files).map(key => (
                    <img
                      alt=""
                      src={URL.createObjectURL(this.state.files[key])}
                      height="200"
                    />
                  ))}
                  <label htmlFor={'none'} className="control-label sr-only">
                    {t('Загрузить Изображение с компьютера')}
                  </label>
                  <div className="control-group">
                    <div className="fileupload fade dropzone">
                      <span className="fileupload-title">
                        {t('Загрузить Изображение с компьютера')}
                      </span>
                      <input
                        multiple="multiple"
                        type="file"
                        onChange={e => this.handleUploadFiles(e.target.files)}
                      />
                    </div>
                    <p className="text-center">{t('или')}</p>
                    <div className="input-group">
                      <input
                        className="form-control ng-untouched ng-pristine ng-valid"
                        name="formImgAddUrl"
                        placeholder={t('Скопировать URL изображения')}
                        type="text"
                        value={this.state.fileUrlFromUploaded}
                        onChange={e =>
                          this.setState({ fileUrlFromUploaded: e.target.value })
                        }
                      />
                      <span className="input-group-btn">
                        <button
                          className="btn btn-default"
                          type="button"
                          onClick={this.handleUploadFilesByUrl}
                        >
                          {t('Добавить')}
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
      </React.Fragment>
    );
  }
}

TasksExecsMaterialsButtonPopUpForm.propTypes = {
  // IN
  exec: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,
  fieldMessage: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    hasSuccessQuery: PropTypes.bool
  }).isRequired,
  initState: PropTypes.func.isRequired,
  changeFieldFiles: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  requestState: selectRequestState(state, props.formReduceName)
});

const mapDispatchToProps = (dispatch, props) => ({
  initState: () => dispatch(initState(props.formReduceName)),
  changeFieldFiles: value =>
    dispatch(changeFieldFiles(props.formReduceName, value)),
  sendRequest: () => dispatch(sendRequest(props.formReduceName, props.exec.id))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TasksExecsMaterialsButtonPopUpForm)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsForms/TasksExecsMaterialsButtonPopUpForm/TasksExecsMaterialsButtonPopUpForm.js